const SvgBreakStatus = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill="#D0AF36" />
    <path
      d="M3 11V10.1111H10.1111V11H3ZM4.77778 9.22222C4.28889 9.22222 3.87037 9.04815 3.52222 8.7C3.17407 8.35185 3 7.93333 3 7.44444V3H10.1111C10.3556 3 10.5648 3.08704 10.7389 3.26111C10.913 3.43519 11 3.64444 11 3.88889V5.22222C11 5.46667 10.913 5.67593 10.7389 5.85C10.5648 6.02407 10.3556 6.11111 10.1111 6.11111H9.22222V7.44444C9.22222 7.93333 9.04815 8.35185 8.7 8.7C8.35185 9.04815 7.93333 9.22222 7.44444 9.22222H4.77778ZM4.77778 8.33333H7.44444C7.68889 8.33333 7.89815 8.2463 8.07222 8.07222C8.2463 7.89815 8.33333 7.68889 8.33333 7.44444V3.88889H3.88889V7.44444C3.88889 7.68889 3.97593 7.89815 4.15 8.07222C4.32407 8.2463 4.53333 8.33333 4.77778 8.33333ZM9.22222 5.22222H10.1111V3.88889H9.22222V5.22222ZM4.77778 8.33333H3.88889H8.33333H4.77778Z"
      fill="white"
    />
  </svg>
)

export default SvgBreakStatus
